import React from 'react';
import ExportButton from '../../../../components/common/ExportButton';
import { Box } from '@material-ui/core';
import connect from '../connect';

function PipelineExportButton({ item, exportPursuits }) {
  const onClick = () => {
    exportPursuits?.({ pipelineId: item?.id });
  };

  return (
    <Box display="flex" alignItems="center" justifyContent="center">
      <ExportButton variant="contained" color="primary" onClick={onClick} />
    </Box>
  );
}

export default connect(PipelineExportButton);
